import React from 'react';

interface SwitchButtonProps {
    labels: string[];
    active: string
    setActive: (value: string) => void
}

const SwitchButton: React.FC<SwitchButtonProps> = ({ labels, active, setActive }) => {

    return (
        <div className="rounded-full flex items-center justify-between bg-[#d1b98b] p-[11px] md:p-[19px] overflow-auto gap-2">
            {labels.map((label, index) => (
                <button
                    key={index}
                    className={`px-6 w-full text-[14px] leading-[12px] md:text-[24px] md:leading-[20px] py-[18px] md:py-[30px] rounded-full transition-colors duration-300
            ${active === label
                            ? 'bg-[#284c1c] text-white font-semibold'
                            : 'text-[#000000] hover:text-white'
                        }`}
                    onClick={() => setActive(label)}
                >
                    {label}
                </button>
            ))}
        </div>
    );
};

export default SwitchButton;